import { useTenantContext } from '../tenant-context/index.tsx';

/**
 * are product suggestions enabled
 */
export const useAreProductSuggestionsEnabled = (): boolean => {
	const tenantContext = useTenantContext();
	return (tenantContext && tenantContext.areProductSuggestionsEnabled) || false;
};
